import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from "@/views/Dashboard.vue";
import Requisites from "@/views/Requisites.vue";
import Deals from "@/views/Deals.vue";
import Settings from "@/views/Settings.vue";
import AccountOperations from "@/views/AccountOperations.vue";
import {UserRole} from "@/models/enum/UserRole";
import Invoices from "@/views/Invoices.vue";
import AdminDashboard from "@/views/AdminDashboard.vue";
import Wallets from "@/views/Wallets.vue";
import Users from "@/views/Users.vue";
import Routing from "@/views/Routing.vue";
import InviteLogin from "@/views/InviteLogin.vue";
import OperatorTraders from "@/views/OperatorTraders.vue";
import RequisitesGroups from "@/views/RequisitesGroups.vue";
import TraderDevices from "@/views/TraderDevices.vue";
import Statistic from "@/views/Statistic.vue";
import AntiFraudAlerts from "@/views/AntiFraudAlerts.vue";
import Transfers from "@/views/Transfers.vue";
import SystemSettings from "@/views/SystemSettings.vue";
import Aggregator from "@/views/Aggregator.vue";
import TraderOperators from "@/views/TraderOperators.vue";
import MerchantOperators from "@/views/MerchantOperators.vue";
import CurrencyRates from "@/views/CurrencyRates.vue";
import OperatorProviders from "@/views/OperatorProviders.vue";
import Currencies from "@/views/Currencies.vue";
import NotificationCenter from "@/views/NotificationCenter.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT_OPERATOR, UserRole.TRADER_TEAM_LEAD, UserRole.REFERRAL]},
    },
    {
        path: '/admin/accounts',
        name: 'adminDashboard',
        component: AdminDashboard,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN]},
    },
    {
        path: '/admin/wallets',
        name: 'wallets',
        component: Wallets,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN]},
    },
    {
        path: '/admin/users/:type?/:id?',
        name: 'users',
        component: Users,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/traders',
        name: 'traders',
        component: OperatorTraders,
        meta: {requiresAuth: true, roles: [UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD]},
    },
    {
        path: '/providers',
        name: 'providers',
        component: OperatorProviders,
        meta: {requiresAuth: true, roles: [UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD]},
    },
    {
        path: '/admin/routing/:tab?',
        name: 'routing',
        component: Routing,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/admin/aggregator/:tab?',
        name: 'aggregator',
        component: Aggregator,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN]},
    },
    {
        path: '/devices',
        name: 'devices',
        component: TraderDevices,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD, UserRole.TRADER, UserRole.TRADER_OPERATOR]},
    },
    {
        path: '/statistic/:tab?',
        name: 'statistic',
        component: Statistic,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD, UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT_OPERATOR, UserRole.REFERRAL]},
    },
    {
        path: '/admin/transfers/:tab?',
        name: 'transfers',
        component: Transfers,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/deals',
        name: 'deals',
        component: Deals,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD, UserRole.ADMIN, UserRole.REFERRAL]},
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: Invoices,
        meta: {requiresAuth: true, roles: [UserRole.MERCHANT, UserRole.MERCHANT_OPERATOR, UserRole.ADMIN]},
    },
    {
        path: '/account-operations',
        name: 'accountOperations',
        component: AccountOperations,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT_OPERATOR, UserRole.ADMIN, UserRole.TRADER_TEAM_LEAD, UserRole.REFERRAL]},
    },
    {
        path: '/requisites',
        name: 'requisites',
        component: Requisites,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.ADMIN, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD]},
    },
    {
        path: '/trader-operators',
        name: 'traderOperators',
        component: TraderOperators,
        meta: {requiresAuth: true, roles: [UserRole.TRADER]},
    },
    {
        path: '/anti-fraud-alerts',
        name: 'antiFraudAlerts',
        component: AntiFraudAlerts,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/notification-center',
        name: 'notificationCenter',
        component: NotificationCenter,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/requisites-groups',
        name: 'requisitesGroups',
        component: RequisitesGroups,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD]},
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            requiresAuth: true,
            roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.OPERATOR, UserRole.TRADER_TEAM_LEAD, UserRole.MERCHANT, UserRole.MERCHANT_OPERATOR, UserRole.ADMIN, UserRole.REFERRAL]
        },
    },
    {
        path: '/system-settings/:tab?',
        name: 'systemSettings',
        component: SystemSettings,
        meta: {
            requiresAuth: true,
            roles: [UserRole.ADMIN]
        },
    },
    {
        path: '/currency-rates',
        name: 'currencyRates',
        component: CurrencyRates,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
        path: '/currencies/:tab?',
        name: 'currencies',
        component: Currencies,
        meta: {requiresAuth: true, roles: [UserRole.ADMIN, UserRole.OPERATOR]},
    },
    {
            path: '/merchant-operators',
            name: 'merchantOperators',
            component: MerchantOperators,
            meta: {requiresAuth: true, roles: [UserRole.MERCHANT]},
    },
    {path: '/login', name: 'login', component: Login},
    {path: '/invite/:token', name: 'inviteLogin', component: InviteLogin},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router

